import React, { useEffect } from 'react';

export const UTMAttribution = () => {
  const name = 'attribution';
  const windowExists = typeof window !== 'undefined';
  const localData = JSON.parse(
    windowExists ? localStorage.getItem(name) : null
  );
  const currentTime = new Date().getTime();
  const timeframe = 3 * 24 * 60 * 60 * 1000; // 3 days
  const expiration = currentTime - timeframe;
  let params;

  const objFromEntries = entries =>
    entries.reduce((prev, curr) => {
      prev[curr[0]] = curr[1];
      return prev;
    }, {});

  if (windowExists) {
    let entries = window.location.search
      .replace('?', '')
      .split('&')
      .map(a => a.split('='))
      .map(b => b.map(c => decodeURI(c)));

    params = objFromEntries(entries);
  } else {
    params = {};
  }

  const timestamp =
    params['utm_source'] || params['utm_medium'] || params['utm_campaign']
      ? currentTime
      : undefined;
  const data = JSON.stringify({
    source: params['utm_source'],
    medium: params['utm_medium'],
    campaign: params['utm_campaign'],
    timestamp: timestamp,
  }); // will resolve as '{}' if all properties = undefined

  //
  const set = () => localStorage.setItem(name, data);
  const remove = () => localStorage.removeItem(name);

  //
  useEffect(() => {
    // if stored data is old, remove stored data
    if (localData?.timestamp < expiration) remove();
    // if new data is available, set new stored data
    if (data !== '{}') set();
  }, []);

  //
  return <></>;
};
